module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Liencres-c27f1da73cbf82bb04d49493ff3353dc.jpg";